import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M145 285c77.017 0 140-63 140-140S222.017 5 145 5C67.983 5 5 68 5 145s62.9829 140 140 140zM91.2593 159c-9.5844 0-16.088-4.7805-16.088-13.8293 0-9.2195 6.1613-14.1707 16.088-14.1707h107.6527c9.9267 0 15.917 4.9512 15.917 14.1707 0 9.0488-6.3325 13.8293-15.917 13.8293H91.2592z"
})), 'DeleteFilledIcon');